/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.InitialSetup.services
 * @name     csm.books.InitialSetup.services.Data.type:OutstandingBankItem
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Represents an outstanding item against a bank account.
 *******************************************************************************/
/* @ngInject */ export function outStandingBankItemConfig(TypeFactoryProvider) {
  /*------------------------------------------*/
  /* Using defaults rather than prototype to  */
  /* make sure default values get serialized. */
  /*------------------------------------------*/
  var defaults = {
    isDeposit: false, // true=Deposit, false=Check, null=Adjustment
    amount: 0, // Change to account balance
    checkNumber: 0, // Check Number - Only for checks
    description: null, // Description
    txDate: null // Transaction date.
  };

  TypeFactoryProvider.addType({
    name: 'Data.OutstandingBankItem',
    $type: 'csm.books.data.setup.OutstandingBankItem, CSMBooks',
    prototype: Object.defineProperties(
      {},
      {
        isCheck: {
          get: function () {
            return this.isDeposit == false;
          }
        },
        isOther: {
          get: function () {
            return this.isDeposit == null;
          }
        },
        type: {
          get: function () {
            return this.isCheck
              ? 'Check'
              : this.isDeposit
                ? 'Deposit'
                : 'Other';
          }
        },

        /*-------------------------------------*/
        /* change - Change in account balance. */
        /*-------------------------------------*/
        change: {
          get: function () {
            return this.isDeposit || this.isOther
              ? this.amount
              : -this.amount;
          },
          set: function (v) {
            this.amount = this.isOther ? v : Math.abs(v);
          }
        },

        /*---------------------------------------------------*/
        /* gridNumber - Check number for grid number column. */
        /*---------------------------------------------------*/
        gridNumber: {
          get: function () {
            return this.isCheck ? this.checkNumber : '';
          },
          set: function (n) {
            this.checkNumber = n;
          }
        }
      }
    ),
    constructor: function () {
      return function (data) {
        /*-----------------------------------------*/
        /* Instantiate defaults for serialization. */
        /*-----------------------------------------*/
        this.defaultConstructor(Object.assign({}, defaults, data));
      };
    }
  });
};
